import type { AllGradeSubject, SchoolType, Semester } from '@mathflat/domain/SchoolSystem'
import type { SchoolTestProvideType } from '@mathflat/domain/SchoolTest'
import { makeAutoObservable } from 'mobx'

import type { SchoolTreeNode } from '../models/SchoolTreeNode.model'

export type SearchStatus = 'initial' | 'searched' | 'cleared'

export class SchoolTestSearchStore {
  static REQUEST_PAGING_SIZE = 20
  private _searchedSchoolList: SchoolTreeNode[] = []
  private _isLastPage = false
  private _page = 1
  private _searchText = ''
  private _searchStatus: SearchStatus = 'initial'
  private _searchGrade?: AllGradeSubject = '1'
  private _searchSemester?: Semester = 1
  private _searchSchoolType?: SchoolType = 'MIDDLE'
  private _provideTypes?: SchoolTestProvideType[] = ['ALL', 'SIMILAR_ONLY', 'PDF_ONLY']

  get searchStatus() {
    return this._searchStatus
  }

  get searchedSchoolList() {
    return [...this._searchedSchoolList]
  }

  get isLastPage() {
    return this._isLastPage
  }

  constructor() {
    makeAutoObservable(this)
  }

  setSearchedSchoolList(schoolList: SchoolTreeNode[]) {
    this._searchedSchoolList = schoolList
  }

  reset(): void {
    this._searchedSchoolList = []
    this._isLastPage = false
    this._page = 1
    this._searchText = ''
  }

  updateSearchStatus(status: SearchStatus) {
    this._searchStatus = status
  }
  get searchText() {
    return this._searchText
  }

  setSearchText(search: string) {
    this._searchText = search
  }
}
